module.exports = __webpack_public_path__ + "img/特产店铺7.a48ac1ad.png";